import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import {
  formatRestaurantDateTime,
} from "@/utils/currency";
import {
  ChevronDown,
  ChevronUp,
} from "lucide-react";
import {
  Search,
  Clock3,
  MapPin,
  Phone,
  Package,
  Bike,
  CheckCircle2,
  Receipt,
  ExternalLink,
} from "lucide-react";
import { formatCurrency } from "../utils/currency";
const API = `${window.location.origin}/api`;

const formatStatus = (value) => {
  if (!value) return "Pending";

  return value
    .replaceAll("_", " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const getStatusColor = (status) => {
  switch (status) {
    case "delivered":
    case "completed":
      return "bg-green-100 text-green-700";

    case "out_for_delivery":
    case "assigned":
      return "bg-blue-100 text-blue-700";

    case "preparing":
    case "pending":
      return "bg-orange-100 text-orange-700";

    default:
      return "bg-slate-100 text-slate-700";
  }
};

export default function TrackOrderPage() {

  const [phone, setPhone] = useState("");
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [loading, setLoading] = useState(false);
  const [restaurant, setRestaurant] = useState(null);

  const { restaurantSlug } = useParams();
  const [searchParams] = useSearchParams();

  const orderId = searchParams.get("order_id");
  useEffect(() => {
    fetchRestaurant();
  }, [restaurantSlug]);
  useEffect(() => {

  if (restaurant && orderId) {
    fetchOrderDetails(orderId);
  }

}, [restaurant, orderId]);
  const fetchRestaurant = async () => {
    try {

      const response = await axios.get(
        `${API}/public/restaurant/${restaurantSlug}`
      );

      setRestaurant(response.data);

    } catch (error) {

      console.error(error);
      toast.error("Restaurant not found");
    }
  };

  const searchOrders = async () => {
    try {

      setLoading(true);

      const response = await axios.get(
        `${API}/orders/track`,
        {
          params: {
            phone,
            restaurant_id: restaurant?.id,
          },
        }
      );

      setOrders(response.data.data || []);

    } catch (error) {

      console.error(error);
      toast.error("Failed to fetch orders");

    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetails = async (id) => {
  try {

    setLoading(true);

    const response = await axios.get(
      `${API}/orders/track/${id}`,
      {
        params: {
          restaurant_id: restaurant?.id,
        },
      }
    );

    const orderData = response.data.data;

    setSelectedOrder(orderData);

    // auto add to orders list if redirected directly
    setOrders((prev) => {

      const exists = prev.find((o) => o.id === orderData.id);

      if (exists) return prev;

      return [orderData, ...prev];
    });

    // auto fill phone
    if (orderData.customer_phone) {
      setPhone(orderData.customer_phone);
    }

  } catch (error) {

    console.error(error);
    toast.error("Failed to fetch order details");

  } finally {

    setLoading(false);
  }
};
const downloadInvoice = async (orderId) => {

  try {

    const response = await axios.get(
      `${API}/public/orders/${orderId}/receipt-pdf`,
      {
        params: {
          restaurant_id: restaurant?.id,
        },
        responseType: "blob",
      }
    );

    // Create blob URL
    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: "application/pdf",
      })
    );

    // Create download link
    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `Receipt-${orderId.slice(-6)}.pdf`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

    // Cleanup
    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error(error);

    toast.error("Failed to download invoice");
  }
};
  return (
    <div className="min-h-screen bg-slate-100 py-10 px-4">

      <div className="max-w-5xl mx-auto">

        {/* Restaurant Header */}
        <div className="bg-white rounded-3xl shadow-sm p-8 mb-8">

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">

            <div>
              <h1 className="text-4xl font-bold text-slate-800">
                {restaurant?.name || "Restaurant"}
              </h1>

              <div className="mt-4 space-y-2 text-slate-600">

                <div className="flex items-center gap-2">
                  <MapPin size={16} />
                  {restaurant?.address}
                </div>

                {/* <div className="flex items-center gap-2">
                  <Phone size={16} />
                  {restaurant?.owner_phone}
                </div> */}

              </div>
            </div>
          </div>
        </div>

        {/* Search */}
        {/* <div className="bg-white rounded-3xl shadow-sm p-6 mb-8">

          <div className="flex flex-col md:flex-row gap-4">

            <div className="relative flex-1">

              <Phone
                size={18}
                className="absolute left-4 top-4 text-slate-400"
              />

              <input
                type="tel"
                placeholder="Enter your mobile number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full border border-slate-200 rounded-2xl pl-12 pr-4 py-4 outline-none focus:ring-2 focus:ring-red-500"
              />

            </div>

            <button
              onClick={searchOrders}
              disabled={loading}
              className="bg-red-600 hover:bg-red-700 transition text-white px-8 rounded-2xl flex items-center justify-center gap-2"
            >

              <Search size={18} />

              {loading ? "Searching..." : "Track Order"}

            </button>

          </div>

        </div> */}

        {/* Orders */}
        {orders.length > 0 && (
          <div className="space-y-4 mb-8">

            <h2 className="text-2xl font-bold text-slate-800">
              Your Orders
            </h2>
         </div>
        )}

            {/* Order Details */}
            {orders.map((order) => (

            <div
                key={order.id}
                className="bg-white rounded-3xl shadow-sm p-6"
            >

                {/* Top Section */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">

                <div>

                    <div className="flex items-center gap-3 mb-3">

                    <Package size={18} />

                    <h3 className="font-bold text-lg">
                        Order #{order?.id?.slice(-6)}
                    </h3>

                    {/* <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                        order.delivery_status || order.order_status
                        )}`}
                    >
                        {formatStatus(
                        order.delivery_status || order.order_status
                        )}
                    </span> */}

                    </div>

                    <div className="space-y-1 text-sm text-slate-500">

                    <div className="flex items-center gap-2">
                        <Receipt size={14} />
                        Payment: {formatStatus(order.payment_status)}
                    </div>

                    <div className="flex items-center gap-2">
                        <Clock3 size={14} />
                         {formatRestaurantDateTime(order.created_at)}
                    </div>

                    </div>

                </div>

                <div className="text-right">

                    <p className="text-3xl font-bold text-slate-800">
                    {formatCurrency(order.grand_total)}
                    </p>

                    <button
                    onClick={() => {
                        if (selectedOrder?.id === order.id) {
                        setSelectedOrder(null);
                        } else {
                        fetchOrderDetails(order.id);
                        }
                    }}
                    className="mt-3 bg-black hover:bg-slate-800 transition text-white px-5 py-3 rounded-2xl flex items-center gap-2"
                    >

                    {selectedOrder?.id === order.id ? (
                        <>
                        Hide Details
                        <ChevronUp size={18} />
                        </>
                    ) : (
                        <>
                        View Details
                        <ChevronDown size={18} />
                        </>
                    )}

                    </button>

                </div>

                </div>

                {/* Order Details */}
                {selectedOrder?.id === order.id && (
                <div className="border-t pt-8 mt-8">
{selectedOrder.order_status === "pending" && (
  <div className="mt-6 bg-green-50 border border-green-200 rounded-2xl p-5">

    <div className="flex items-start gap-3">

      <CheckCircle2
        className="text-green-600 mt-1"
        size={24}
      />

      <div>

        <h3 className="text-lg font-bold text-green-700">
          Order Placed Successfully!
        </h3>

        <p className="text-green-600 mt-1">
          We’ve received your order and it will be ready soon.
        </p>

      </div>

    </div>

  </div>
)}
                    {/* Order Header */}
                    <div className="flex items-center justify-between mb-6 flex-wrap gap-3">

                    {/* <div>
                        <h2 className="text-2xl font-bold text-gray-800">
                        Order #{selectedOrder.id?.slice(-6)}
                        </h2>

                    </div>

                    <div
                        className={`px-4 py-2 rounded-full text-sm font-semibold
                        ${
                        selectedOrder.delivery_type === "pickup"
  ? selectedOrder.kitchen_status === "ready"
  : selectedOrder.delivery_status === "delivered"
                            ? "bg-green-100 text-green-700"
                            : selectedOrder.delivery_status === "out_for_delivery"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-yellow-100 text-yellow-700"
                        }
                        `}
                    >
                        {selectedOrder.delivery_type === "pickup"
                        ? formatStatus(selectedOrder.kitchen_status)
                        : formatStatus(selectedOrder.delivery_status)}
                    </div> */}
{/* Order Placed Message */}


                    </div>

                    {/* Summary */}
                    <div className="bg-gray-50 rounded-xl p-5 border space-y-3">

                    <div className="flex justify-between">
                        <span className="text-gray-500">
                        Order Status
                        </span>

                        <span className="font-semibold capitalize">
                        {selectedOrder.order_status ==="pending" ? "Recieved" : formatStatus(selectedOrder.order_status)}
                        </span>
                    </div>

                    <div className="flex justify-between">
                        <span className="text-gray-500">
                        Payment Status
                        </span>

                        <span
                        className={`font-semibold ${
                            selectedOrder.payment_status === "paid"
                            ? "text-green-600"
                            : "text-orange-600"
                        }`}
                        >
                        {selectedOrder.payment_status}
                        </span>
                    </div>

                    {/* Pickup Order */}
                    {selectedOrder.delivery_type === "pickup" ? (

                      <div className="flex justify-between">
                        <span className="text-gray-500">
                          Kitchen Status
                        </span>

                        <span className="font-semibold capitalize">
                          {formatStatus(selectedOrder.kitchen_status || "new")}
                        </span>
                      </div>

                    ) : (

                      <div className="flex justify-between">
                        <span className="text-gray-500">
                          Delivery Status
                        </span>

                        <span className="font-semibold capitalize">
                          {formatStatus(selectedOrder.delivery_status || "pending")}
                        </span>
                      </div>

                    )}

                    <div className="flex justify-between">
                        <span className="text-gray-500">
                        Total Amount
                        </span>

                        <span className="font-bold text-lg">
                        {formatCurrency(selectedOrder.grand_total)}
                        </span>
                    </div>
                    <button
                      onClick={() => downloadInvoice(selectedOrder.id)}
                      className="w-full mt-4 bg-black hover:bg-slate-800 transition text-white py-3 rounded-xl flex items-center justify-center gap-2 font-semibold"
                    >
                      <Receipt size={18} />
                      Download Invoice
                    </button>

                    </div>

                    {/* Live Tracking */}
                    {selectedOrder.delivery_type !== "pickup" &&
                      selectedOrder.uber_tracking_url &&
                      selectedOrder.delivery_status !== "delivered" && (
                            <div className="mt-8 bg-blue-50 border border-blue-200 rounded-2xl p-6 text-center">

                            <Bike className="mx-auto mb-4 text-blue-600" size={42} />

                            <h3 className="text-2xl font-bold text-slate-800">
                                Live Delivery Tracking
                            </h3>

                            <p className="text-slate-600 mt-2 mb-5">
                                Your order is on the way. Track your delivery partner live.
                            </p>

                            <a
                                href={selectedOrder.uber_tracking_url}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 transition text-white px-6 py-3 rounded-2xl font-semibold"
                            >
                                Track Delivery
                                <ExternalLink size={18} />
                            </a>

                            </div>
                        )}

                    {/* Delivered Message */}
                    {/* Delivered / Pickup Ready */}
                    {selectedOrder.delivery_type === "pickup" ? (

                      selectedOrder.kitchen_status === "ready" && (
                        <div className="mt-8 bg-green-50 border border-green-200 rounded-xl p-5 text-center">

                          <h3 className="text-xl font-bold text-green-700">
                            Order Ready For Pickup
                          </h3>

                          <p className="text-green-600 mt-2">
                            Please collect your order from the restaurant.
                          </p>

                        </div>
                      )

                    ) : (

                      selectedOrder.delivery_type === "pickup"
  ? selectedOrder.kitchen_status === "ready"
  : selectedOrder.delivery_status === "delivered" && (
                        <div className="mt-8 bg-green-50 border border-green-200 rounded-xl p-5 text-center">

                          <h3 className="text-xl font-bold text-green-700">
                            Order Delivered Successfully
                          </h3>

                          <p className="text-green-600 mt-2">
                            Thank you for ordering with us.
                          </p>

                        </div>
                      )

                    )}

                    {/* Items */}
                    <div className="mt-8">

                    <h3 className="text-xl font-bold mb-4">
                        Ordered Items
                    </h3>

                    <div className="space-y-3">

                        {selectedOrder.items?.map((item, index) => (
                        <div
                            key={index}
                            className="border rounded-xl p-4 flex justify-between items-center"
                        >

                            <div>
                            <p className="font-semibold text-gray-800">
                                {item.item_name}
                            </p>

                            <p className="text-sm text-gray-500">
                                Quantity: {item.quantity}
                            </p>
                            </div>

                            <div className="font-bold text-lg">
                            {formatCurrency(item.price)}
                            </div>

                        </div>
                        ))}

                    </div>

                    </div>

                </div>
                )}

            </div>

            ))}
      </div>

    </div>
  );
}